import { render } from "./IndexContactPage.vue?vue&type=template&id=b810c312"
import script from "./IndexContactPage.vue?vue&type=script&lang=js"
export * from "./IndexContactPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__